/* NXTWAVE quick-add.
   Loaded once from layout/theme.liquid. Everything is delegated off `document`
   so it keeps working when Shopify re-renders the cart drawer (injected HTML
   never re-runs inline <script> tags). */
(function () {
  if (window.nxtQuickAddBound) return;
  window.nxtQuickAddBound = true;

  /* Pick a size: repaint the pills, swap the price, retarget the form. */
  document.addEventListener('click', function (e) {
    var size = e.target.closest && e.target.closest('.nxtqa__size');
    if (!size) return;
    var row = size.closest('[data-nxtqa-row]');
    if (!row) return;

    row.querySelectorAll('.nxtqa__size').forEach(function (b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-checked', 'false');
    });
    size.classList.add('is-active');
    size.setAttribute('aria-checked', 'true');

    var input = row.querySelector('input[name="id"]');
    if (input) input.value = size.dataset.id;

    var now = row.querySelector('.nxtqa__now');
    if (now) now.textContent = size.dataset.price;

    var was = row.querySelector('.nxtqa__was');
    if (was) {
      if (size.dataset.compare) {
        was.textContent = size.dataset.compare;
        was.hidden = false;
      } else {
        was.hidden = true;
      }
    }
  });

  /* Confirm the add on the button itself. In the drawer the row is usually
     replaced by the re-render before this lands, which is fine. */
  document.addEventListener('submit', function (e) {
    var row = e.target.closest && e.target.closest('[data-nxtqa-row]');
    if (!row) return;
    var btn = row.querySelector('.nxtqa__add');
    var label = btn && btn.querySelector('.nxtqa__add-label');
    if (!label) return;

    var id = (row.querySelector('input[name="id"]') || {}).value;
    var original = label.dataset.original || label.textContent;
    label.dataset.original = original;
    label.textContent = 'Adding…';

    setTimeout(function () {
      if (!row.isConnected) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!row.isConnected) return;
          var err = row.querySelector('.hdt-error-message');
          var failed = err && err.textContent.trim() !== '';
          var inCart = (cart.items || []).some(function (i) { return String(i.id) === String(id); });
          if (inCart && !failed) {
            btn.classList.add('is-added');
            label.textContent = 'Added';
          } else {
            label.textContent = original;
          }
          setTimeout(function () {
            btn.classList.remove('is-added');
            label.textContent = original;
          }, 1600);
        })
        .catch(function () { label.textContent = original; });
    }, 700);
  }, true);
})();
